import React from 'react'
import './Cover.css'

const Cover = () => {
  return (
    <div>
      <img
        className='cover'
        src='https://wallpapershome.com/images/wallpapers/mirte-maas-3840x2160-top-fashion-models-2015-model-dress-shoes-3684.jpg'
        alt=''
      />
    </div>
  )
}

export default Cover
